import React, {ReactNode} from 'react';
import {Title, Flex, AIStarIcon, Text} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {FormData} from '../DialogHeader';
import texts from '../../texts';
import {getMappedFields} from '../../utils/utils';

type Props = {
    suggestion: FormData;
    renderSectionContent: (records, sectionData) => ReactNode;
    suggestionSectionRef: React.RefObject<HTMLDivElement>;
};

export const SuggestionSection = (props: Props) => {
    const {suggestion, renderSectionContent, suggestionSectionRef} = props;
    const mappedFields = getMappedFields(suggestion);
    const isEmpty = mappedFields.length === 0;

    return (
        <div className={styles.suggestionContainer} ref={suggestionSectionRef}>
            <div className={styles.suggestionSection}>
                <Flex justifyContent="flex-start" componentClasses={styles.suggestionTitle}>
                    <div className={styles.icon}>
                        <AIStarIcon />
                    </div>
                    <Title skin="h5" textColor="primary-700" text={texts.recommendation_title} />
                </Flex>
                <div className={styles.sectionHeader}>
                    <button className={styles.toggleBtn} />
                    <Title
                        skin="h6"
                        textColor="secondary-400"
                        componentClasses={styles.sectionTitle}
                    >
                        {suggestion.formTitle}
                    </Title>
                </div>
                <div className={styles.sectionContent}>
                    {isEmpty ? (
                        <Text tag="div" skin="paragraph-2" textColor="secondary-400">
                            {texts.no_details_msg}
                        </Text>
                    ) : (
                        renderSectionContent(mappedFields, suggestion)
                    )}
                </div>
            </div>
        </div>
    );
};
